module.exports = __webpack_public_path__ + "static/img/1.d3af9f8c.svg";